import { useContext } from 'react';
import { GraphSessionRangeContext } from '../GraphSessionRangeContext';

export const useGraphSessionRange = () => {
  return useContext(GraphSessionRangeContext);
};
